import { Injectable } from '@angular/core';
import { SupportAccessibilityChecksRepoService } from '../../api/accessibility-checks/support-accessibility-checks-repo.service';

/**
 * Service to handle Support Center Accessibility Check requests
 */
@Injectable({
    providedIn: 'root',
})
export class SupportAccessibilityCheckService {

    constructor (
        private supportAccessibilityChecksRepoService: SupportAccessibilityChecksRepoService,
    ) {}

    /**
     * Get article
     * @param id - Id of the Support Center Accessibility Check ID, not to be confused with the actual Accessibility Check ID
     * @param params - Query Params
     * @returns Promise containing the article
     */
    get (id: any, params?: any): any {
        return this.supportAccessibilityChecksRepoService.get(id, params);
    }

    /**
     * Get a Support Center Accessibility Check
     * @param params - Query Params
     */
    getAll (params?: any): any {
        return this.supportAccessibilityChecksRepoService.getAll(params);
    }

    /**
     * Get the Decision Tree Collection related to the specified Accessibility Check
     * @param check - Accessibility Check
     */
    getDecisionTree (check: any): any {
        return this.supportAccessibilityChecksRepoService.getDecisionTree(check);
    }
}
